"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

var references = __importStar(require("../../../common/casualReferences"));

var ENCasualDateParser = /*#__PURE__*/function (_AbstractParserWithWo) {
  _inherits(ENCasualDateParser, _AbstractParserWithWo);

  var _super = _createSuper(ENCasualDateParser);

  function ENCasualDateParser() {
    _classCallCheck(this, ENCasualDateParser);

    return _super.apply(this, arguments);
  }

  _createClass(ENCasualDateParser, [{
    key: "innerPattern",
    value: function innerPattern(context) {
      return /(nu|vandaag|vanacht|morgen|morgend|gisteren)(?=\W|$)/i;
    }
  }, {
    key: "innerExtract",
    value: function innerExtract(context, match) {
      var lowerText = match[0].toLowerCase();
      var component = context.createParsingComponents();

      switch (lowerText) {
        case "nu":
          return references.now(context.refDate);

        case "vandaag":
          return references.today(context.refDate);

        case "morgen":
        case "morgend":
          return references.tomorrow(context.refDate);

        case "gisteren":
          return references.yesterday(context.refDate);

        case "vanacht":
          return references.tonight(context.refDate);
      }

      return component;
    }
  }]);

  return ENCasualDateParser;
}(AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking);

exports.default = ENCasualDateParser;